// Bare /liff/incidents entry — registered LIFF endpoint URL for incident.
// We init LIFF then list recent incidents to pick from.

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLiff } from "../../../liff/index.js";
import { fetchManagerToday, type ManagerTodayData } from "../../../liff/api.js";
import { MobileShell, Card, CardHeader, MobileSpinner, EmptyMobile, SeverityPill } from "../../../liff/components/Mobile.js";

export function IncidentPickerPage(): React.ReactElement {
  const { session } = useLiff();
  const nav = useNavigate();
  const [data, setData] = useState<ManagerTodayData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!session) return;
    fetchManagerToday(session.tenant_id, session.session_token)
      .then(setData)
      .catch((e: unknown) => setError((e as Error).message));
  }, [session]);

  if (error) return (
    <MobileShell title="無法載入事件列表"><Card><p className="text-sm text-danger">{error}</p></Card></MobileShell>
  );
  if (!data) return <MobileSpinner />;
  return (
    <MobileShell title="近期事件" subtitle="點選任一事件以檢視細節">
      <Card>
        <CardHeader title="未結案 / 近 24 小時" hint={`${data.top_incidents.length} 筆`} />
        {data.top_incidents.length === 0 ? (
          <EmptyMobile title="沒有事件 🎉" />
        ) : (
          <ul className="divide-y divide-border-subtle -my-2">
            {data.top_incidents.map((i) => (
              <li key={i.id}>
                <button
                  onClick={() => nav(`/liff/incidents/${encodeURIComponent(i.id)}`)}
                  className="w-full text-left py-3 flex items-start justify-between gap-2"
                >
                  <div className="min-w-0">
                    <p className="text-sm font-medium truncate">{i.title}</p>
                    <p className="text-[11px] text-text-muted">{i.site_name} · {i.occurred_at_local} · {i.status}</p>
                  </div>
                  <SeverityPill severity={i.severity} />
                </button>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </MobileShell>
  );
}
